import React from 'react';
import Result from 'antd/lib/result';
import 'antd/lib/result/style/index';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';


function KycSuccess() {
  const history = useHistory()

  // Whichever screen the KYC form was opened from (account settings or fee
  // management) is carried through as location state, so the back icon can
  // return there directly instead of landing back on the KYC form itself.
  const handleBackPress = () => history.push(history.location?.state?.from || '/account-settings');

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div>
                <ArrowLeftOutlined
                    style={{ fontSize: 20, cursor: 'pointer', color: '#000' }}
                    onClick={handleBackPress}
                />
            </div>
            <div className="r-c-c-c" style={{ flex: 1 }}>
                <div className="r-c-c">
                    <img src={require('Assets/ill-pending.svg').default}  />
                </div>
                <div className="color-purple text-sm bold-600 r-c-c"
                >KYC Under Review</div>
                <div className="text-center  ">
                    {/* The details and documents you had submitted are currently being verified. For any further assistance please drop us a mail at sales@aulas.ai */}
                    Your submitted details and documents are being reviewed. We will notify you once the verification is complete. For assistance, contact us at{" "} <a
                      href="mailto:sales@aulas.ai"
                      style={{ color: '#594099', textDecoration: 'underline' }}
                  >
                       sales@aulas.ai
                  </a>.
                </div>
                <div className="r-c-c m-t-20">
                    <Button type="primary" shape="round" style={{width:200}} onClick={() => history.push('/kyc-form', { from: history.location?.state?.from })}>View submitted details</Button>
                </div>
            </div>

      </div>

    )

}


export default KycSuccess;
